import { Link } from "react-router-dom";
import { Users, CalendarDays, MapPin, ArrowRight } from "lucide-react";

// Countdown banner linking to the RSVP list of the next upcoming event.
export const NextEventBanner = ({ nextEvent }) => (
  <Link
    to={`/admin/inscricoes?event=${encodeURIComponent(nextEvent.slug)}`}
    className="mt-10 block bg-[hsl(var(--primary))] text-white p-8 hover:bg-[hsl(var(--primary))]/95 transition-colors relative overflow-hidden"
    data-testid="dashboard-next-event"
  >
    <div className="absolute inset-0 grain pointer-events-none opacity-30" />
    <div className="relative grid sm:grid-cols-[auto_1fr_auto] items-center gap-6">
      <div className="text-center">
        <div className="display-heading text-6xl sm:text-7xl text-[hsl(var(--accent))] tabular-nums leading-none">
          {nextEvent.days_until}
        </div>
        <div className="mt-1 text-[10px] tracking-[0.22em] uppercase text-white/70">
          {nextEvent.days_until === 0 ? "hoje" : nextEvent.days_until === 1 ? "dia" : "dias"}
        </div>
      </div>
      <div className="min-w-0">
        <div className="text-[11px] tracking-[0.22em] uppercase text-[hsl(var(--accent))]">Próximo evento</div>
        <h2 className="mt-1 display-heading text-2xl sm:text-3xl leading-tight">{nextEvent.title}</h2>
        <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-xs text-white/80">
          {nextEvent.date_str && (
            <span className="inline-flex items-center gap-1.5"><CalendarDays className="h-3.5 w-3.5" />{nextEvent.date_str}</span>
          )}
          {nextEvent.location && (
            <span className="inline-flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" />{nextEvent.location}</span>
          )}
          <span className="inline-flex items-center gap-1.5"><Users className="h-3.5 w-3.5" />{nextEvent.rsvp_count} {nextEvent.rsvp_count === 1 ? "inscrito" : "inscritos"}</span>
        </div>
      </div>
      <div className="hidden sm:flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-[hsl(var(--accent))]">
        Ver inscritos <ArrowRight className="h-4 w-4" />
      </div>
    </div>
  </Link>
);
